<template>
	<img
		src="/images/notifications/team-alignment.svg"
		alt=""
		aria-hidden="true"
	/>
</template>

<script>
export default { name: 'IconTeamAlignment' }
</script>
